export enum ClosingTheGapStatusEnum {
    NotSpecified = '0',
    Yes = '1',
    No = '2'
}